import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { Modal, Button, Container, Form } from "react-bootstrap";
import copyIcon from "../../../assets/svgs/copyIcon.svg";
import { useNavigate } from "react-router-dom";
import copyTextToClipboard from "../../../helper/common/copyToClipboard";
// import searchIcon from "../../../assets/icons/search_icon.svg";
import searchIcon from "../../../assets/icons/search_icon.svg";
import arrowDownIcon from "../../../assets/icons/down_arrow.svg";
import "../../searchbarForEditCampaign.css";
import getClientData from "../../../helper/clientData/getClientData";
import { masterApi } from "../../../apis/masterApi";
import {
  TOAST_POSITION_TOP_RIGHT,
  TOAST_SUCCESS,
  TOAST_DANGER,
} from "../../../constant/HardTypes";
import { useGlobalContext } from "../../../context/global";
import useUserDetails from "../../../helper/userData/useUserDetails";
import {toast} from 'react-toastify';
// import SearchbarForEditCampaign from "../../searchbarForEditCampaign";
import Select from 'react-select';
import {encodeData} from '../../../helper/common/encodeData'
import { generateIFrameReportUrl, getClientAccountDetails, getClientDataFromAdyogiAPI, getPlatformStatus } from "../../../helper/clientData/utils";
import removeDuplicateObjectsFromArray from "../../../helper/common/removeDuplicateObjectsFromArray";
import { Box, Button as MuiButton, Card, CardContent, CircularProgress, Divider, IconButton, Stack, Tooltip, Typography } from "@mui/material";

const PortfoliCreationModal = () => {
  // State
  const [word, setWord] = useState("");
  const [buttonStatus, setButtonStatus] = useState(false);
  const [currentClient, setCurrentClient] = useState({ name: "Choose Client", account_id: "", client_id: "" });
  const [clientsDataToShow, setClientsDataToShow] = useState([]);
  const {
    show,
    setShow,
    showAlert,
    modalFor,
    allClientsData,
    setAllClientsData,
    portfolio,
    setPortfoliosArray,
    clientId,
    setClientId,
    clientAccountId,
    setClientAccountId,
    clientData,
    setClientData,
    campaignData,
    setCampaignData,
    adGroupData,
    setAdGroupData,
    adSetData,
    setAdSetData,
    reportData,
    setReportData,
    noMultiuserClients,
    setNoMultiuserClients,
    setShowCMSLink,
    updatePlatform
  } = useGlobalContext();

  const getSort = (list, clm) => {
    const sortedData = list.sort((a, b) => {
      const nameA = a[clm]?.toLowerCase();
      const nameB = b[clm]?.toLowerCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    return sortedData;
  }

  const navigate = useNavigate();
  const [userDetails] = useUserDetails();
  const isMultiUser = userDetails?.user.multiUser;
  const modalHeading =
    modalFor !== "switch-client"
      ? ("Create Portfolio")
      : (isMultiUser === "no"
        ? ("Switch Account")
        : ("Switch Client"));
  const defaultMysqlClientId =
    userDetails?.user?.clientId ||
    (() => {
      try {
        return JSON.parse(localStorage.getItem("defaultMysqlClientId") || "null");
      } catch {
        return null;
      }
    })();

  const readStoredDefaultName = () => {
    try {
      const stored = JSON.parse(
        localStorage.getItem("defaultMysqlClientName") || "null"
      );
      if (stored && stored !== defaultMysqlClientId) return stored;
    } catch {
      // ignore
    }
    try {
      const activeId = JSON.parse(localStorage.getItem("clientId") || "null");
      const activeName = JSON.parse(localStorage.getItem("clientName") || '""');
      if (activeId === defaultMysqlClientId && activeName) return activeName;
    } catch {
      // ignore
    }
    return null;
  };

  const noMultiuserClientsData = (() => {
    const mapped = (noMultiuserClients ?? []).map((category) => ({
      client_id: category?.parse_client_id,
      account_id: Math.random() * 999,
      name: category?.name,
    }));
    // Ensure MySQL default client stays selectable after switching to a mapped account
    if (
      defaultMysqlClientId &&
      !mapped.some((item) => item?.client_id === defaultMysqlClientId)
    ) {
      mapped.unshift({
        client_id: defaultMysqlClientId,
        account_id: Math.random() * 999,
        name: readStoredDefaultName() || defaultMysqlClientId,
      });
    }
    return mapped;
  })();

  const sortnoMultiuserClientsData = getSort([...noMultiuserClientsData], 'name');
  const [noMultiuserData, setNoMultiuserData] = useState(sortnoMultiuserClientsData);
  const [isSwitching, setIsSwitching] = useState(false);
  const [isFetchingClients, setIsFetchingClients] = useState(false);
  const [b4ClientsData, setB4ClientsData] = useState([]);
  const [copiedField, setCopiedField] = useState("");
  const copyTimeoutRef = useRef(null);
  const defaultNameResolvedRef = useRef(false);
  const b4ClientsFetchedRef = useRef(false);

  useEffect(() => {
    setNoMultiuserData(getSort([...noMultiuserClientsData], "name"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noMultiuserClients, defaultMysqlClientId]);

  // Ensure default MySQL client is in the list with the correct MySQL display name
  useEffect(() => {
    if (isMultiUser !== "no" || !defaultMysqlClientId) return;
    let cancelled = false;

    const resolveDefaultClientDisplayName = async () => {
      const list = noMultiuserClients ?? [];
      const existing = list.find(
        (acc) =>
          acc?.parse_client_id === defaultMysqlClientId ||
          acc?.client_id === defaultMysqlClientId
      );

      let resolvedName = readStoredDefaultName();

      // Fetch authoritative name once from MySQL (same source header uses via getClientData)
      if (!defaultNameResolvedRef.current) {
        try {
          const data = await masterApi(
            {},
            "clientData",
            false,
            "Get",
            defaultMysqlClientId
          );
          if (data?.data?.data?.[0]?.name) {
            resolvedName = data.data.data[0].name;
          } else if (!resolvedName) {
            const b4a = await getClientDataFromAdyogiAPI(defaultMysqlClientId);
            const obj = b4a?.data?.results?.[0];
            const { accountName } = getClientAccountDetails(obj ?? {});
            resolvedName =
              accountName ||
              obj?.amazon_setup?.profile_info?.accountInfo?.name ||
              obj?.name ||
              defaultMysqlClientId;
          }
        } catch (error) {
          console.log(error);
        }
        if (!cancelled) {
          defaultNameResolvedRef.current = true;
        }
      }

      if (cancelled) return;
      resolvedName = resolvedName || defaultMysqlClientId;

      localStorage.setItem(
        "defaultMysqlClientId",
        JSON.stringify(defaultMysqlClientId)
      );
      localStorage.setItem(
        "defaultMysqlClientName",
        JSON.stringify(resolvedName)
      );

      if (!existing) {
        const updated = [
          {
            parse_client_id: defaultMysqlClientId,
            name: resolvedName,
            isDefaultMysqlClient: true,
          },
          ...list,
        ];
        setNoMultiuserClients(updated);
        localStorage.setItem("userAccounts", JSON.stringify(updated));
        return;
      }

      if (existing.name !== resolvedName) {
        const updated = list.map((acc) =>
          acc?.parse_client_id === defaultMysqlClientId ||
          acc?.client_id === defaultMysqlClientId
            ? { ...acc, name: resolvedName, isDefaultMysqlClient: true }
            : acc
        );
        setNoMultiuserClients(updated);
        localStorage.setItem("userAccounts", JSON.stringify(updated));
      }
    };

    resolveDefaultClientDisplayName();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMultiUser, defaultMysqlClientId, noMultiuserClients, setNoMultiuserClients]);

  // Methods
  const handleChange = (e) => {
    setWord(e.target.value);
  };

  // const filterClients = (e) => {
  //   const filteredClients = (
  //     isMultiUser === "no" ? noMultiuserClientsData : allClientsData
  //   )?.filter((data) => {
  //     if (e.target.value === "") {
  //       return data;
  //     } else {
  //       const dataInString = data?.name + data?.account_id + data?.client_id;
  //       return dataInString
  //         ?.toLowerCase()
  //         ?.includes(e.target.value.toLowerCase());
  //     }
  //   });
  //   isMultiUser !== "no"
  //     ? setClientsDataToShow([
  //       { name: "Choose Client", account_id: "", client_id: "" },
  //       ...filteredClients,
  //     ])
  //     : setNoMultiuserData([...filteredClients]);
  // };

  function setCurrentClientData(mainData) {
    const { reportData, clientData } = mainData;
    const { client_id, account_id, default_bid } = clientData;
    setClientData(clientData);
    localStorage.setItem("reference",JSON.stringify(clientData))
    setClientId(client_id);
    setAdGroupData({
      ...adGroupData,
      account_id: account_id,
      amz_default_bid: default_bid,
    });
    setCampaignData({
      ...campaignData,
      tenant_id: client_id,
      account_id: account_id,
    });
    setAdSetData({ ...adSetData, tenant_id: client_id });
    setClientAccountId(account_id);
    setReportData(reportData);
  }

  useEffect(() => {
    setAllClientsData(getSort(allClientsData, 'name'))
  }, [allClientsData])


  const getClientsFromMyntraAndFlipkart = async () => { 
    try {
      const url = `${process.env.REACT_APP_LOGIN_API}/api/B4APIs/getAllClients`
      const config = {
        method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${process.env.REACT_APP_AUTHORIZATION_FOR_NORMAL_USER}`
            }
      }
      const data = await axios.get(url,config);
      if(data?.status === 200) {
        const clients = Array.isArray(data?.data) ? data.data : [];
        setB4ClientsData(clients);
        b4ClientsFetchedRef.current = true;
        return clients;
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getFlagAttritedField = (setup) => {
    const flagValue = setup?.flag_attrited || "No";
    return {
      label: "Flag Attrited",
      value: flagValue,
      valueColor:
        String(flagValue).toLowerCase() === "yes" ? "#D32F2F" : undefined,
    };
  };

  const getMarketplaceFields = (setup) => {
    if (!setup) return null;
    const fields = [];
    if (setup?.profile_id) {
      fields.push({ label: "A Account", value: setup.profile_id });
    }
    if (setup?.b_account) {
      fields.push({ label: "B Account", value: setup.b_account });
    }
    fields.push(getFlagAttritedField(setup));
    return fields.length > 0 ? fields : null;
  };

  const getSelectedClientDetails = (client, b4Client) => {
    const amazonSetup = b4Client?.amazon_setup;
    const flipkartSetup = b4Client?.flipkart_setup;
    const myntraSetup = b4Client?.myntra_setup;
    const noPlatformSetups =
      !amazonSetup && !flipkartSetup && !myntraSetup;
    const amazonProfileId = amazonSetup?.profile_id
      ? amazonSetup.profile_id
      : noPlatformSetups
        ? client?.account_id || client?.profile_id || ""
        : "";
    const amazonFields = [];

    if (amazonProfileId) {
      amazonFields.push({ label: "Profile Id", value: amazonProfileId });
    }
    if (client?.account_type) {
      amazonFields.push({ label: "Client Account Type", value: client.account_type });
    }
    if (amazonSetup || (noPlatformSetups && amazonProfileId)) {
      amazonFields.push(getFlagAttritedField(amazonSetup));
    }

    return {
      baseItems: [
        { label: "Client Name", value: client?.name },
        { label: "Client Id", value: client?.client_id },
      ],
      amazonFields: amazonFields.length > 0 ? amazonFields : null,
      flipkartFields: getMarketplaceFields(flipkartSetup),
      myntraFields: getMarketplaceFields(myntraSetup),
    };
  };
  // Fetching Methods

  const convertFlipkartAndMyntraData = (clientsData) => {
    return clientsData?.reduce((acc,curr) => {
      const setupKey = (curr?.flipkart_setup && curr?.flipkart_setup?.profile_id) ? 'flipkart_setup' : 'myntra_setup'
    if(curr[setupKey] && curr[setupKey]?.profile_id) {
     const {accountName,accountType,profileId} = getClientAccountDetails(curr)
      acc.push({
        ...curr,
        name: accountName,
        account_id: profileId,
        client_id: curr?.objectId,
        account_type: accountType,
        isMyntraOrFlipkart:true,
        platform: setupKey === 'flipkart_setup' ? 'flipkart' : 'myntra'
      })
    }

    return acc
    },[])
  }

  const convertExistingData = (amazonData,flipKartData) => {
    return amazonData?.map((data) => {
      const sameIdData = flipKartData?.find((flipData) => {
        return data?.client_id === flipData?.client_id 
      }) ?? {}
      const flipkartData = (sameIdData['flipkart_setup'] && sameIdData['flipkart_setup']?.profileId) ? sameIdData['flipkart_setup'] : {}
      const isFlipKartDataPresent = Object.keys(flipkartData).length > 0
      const flipkart_setup = isFlipKartDataPresent ? flipkartData : {}
      const myntraData = (sameIdData['myntra_setup'] && sameIdData['myntra_setup']?.profileId) ? sameIdData['myntra_setup'] : {}
      const isMyntraDataPresent = Object.keys(myntraData)?.length > 0
      const myntra_setup = isMyntraDataPresent ? myntraData : {}
      return {...data,...(isFlipKartDataPresent && {flipkart_setup}),...(isMyntraDataPresent && {myntra_setup}),platform:'amazon'}

    })
  }

  const getAllClients = async () => {
    setIsFetchingClients(true);
    try {
      const [amazonResponse,flipkartAndMyntraResponse] = await Promise.all([getclientdata(),getClientsFromMyntraAndFlipkart()]);
      const modifiedFlipkartData = convertFlipkartAndMyntraData(flipkartAndMyntraResponse)
      const amazonModifiedData = convertExistingData(amazonResponse,modifiedFlipkartData)
      const overallData = removeDuplicateObjectsFromArray(amazonModifiedData.concat(modifiedFlipkartData),true,'client_id'); 
      const allData = getSort(overallData,'name');
      setAllClientsData(allData ?? [])
    } catch (error) {
      console.log(error)
    } finally {
      setIsFetchingClients(false);
    }
  }

  const getclientdata = async () => {
    return await  axios
      .get(
        "https://adyogiadsapi.adyogi.com/accounts?type=amazon_ad_account&fields=account_id,client_id,name,profile_id,account_type"
      )
      .then((res) => {
        if (res?.data?.data) {
          return res?.data?.data
        } else {
          alert("Some Unknown Error Occured");
        }
      });
  };

  // Effects

  useEffect(() => {
    if (modalFor === "switch-client" && allClientsData.length === 0) {
      getAllClients();
    }
  }, []);

  // Load raw B4 client setups once per session for Selected Client Details
  useEffect(() => {
    if (
      show &&
      modalFor === "switch-client" &&
      !b4ClientsFetchedRef.current &&
      b4ClientsData.length === 0
    ) {
      getClientsFromMyntraAndFlipkart();
    }
  }, [show, modalFor, b4ClientsData.length]);

  useEffect(() => {
    setClientsDataToShow([
      { name: "Choose Client", account_id: "", client_id: "" },
      ...allClientsData,
    ]);
  }, [allClientsData]);

  // API Integration needs to be done here
  const integrateApi = async (dataPassed, e) => {
    try {
      if (dataPassed === "") {
        e.preventDefault();
        alert("Please Enter Something");
        return;
      }
      const data = {
        name: dataPassed,
        amz_in_budget: true,
        source: "amazon",
        amz_state: "ENABLED",
      };
      setButtonStatus(true);
      const result = await masterApi(data, "createPortfolio", false, "post");
      if (result?.statusCode !== 200) {
        // showAlert(TOAST_POSITION_TOP_RIGHT, 10000, {
        //   backgroundColor: TOAST_DANGER,
        //   title: "Success",
        //   description: "Error While Creating Portfolio",
        // });
        toast.error('Unknown error occurred while creating Porfolio')
        setButtonStatus(false);
        return;
      }
      setButtonStatus(false);
      // showAlert(TOAST_POSITION_TOP_RIGHT, 10000, {
      //   backgroundColor: TOAST_SUCCESS,
      //   title: "Success",
      //   description: "Portfolio has been created successfully",
      // });
      toast.success('Portfolio has been created successfully')
      setShow(false);
      setPortfoliosArray([...portfolio, dataPassed]);
      return result;
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = () => {
    integrateApi(word);
  };

  
  const fetchData = async (clientId) => {
    try {
      const response = await getClientDataFromAdyogiAPI(clientId);
      const productType = response?.data?.results[0]?.amazon_setup?.product_type
      localStorage.setItem("product_type",JSON.stringify(productType ?? "internal"))
      if( productType==="Self serve") {
        setShowCMSLink(false)
      } else {
        setShowCMSLink(true)
      }
      
    } catch (error) {
      throw error;
    }
  }

  const handleSwitch = async (passedClientId) => {
    try {
      setIsSwitching(true);
      await fetchData(passedClientId)
      const mainData = await getClientData(
        passedClientId,
        true,
        userDetails?.user?.email
      );
      if ("clientData" in mainData) {
        setCurrentClientData(mainData);
        setShow(false);
        const {myntraStatus,amazonStatus,flipkartStatus} = getPlatformStatus(mainData?.clientData ?? {});
        const platform = amazonStatus ? 'amazon' : myntraStatus ? 'myntra' : flipkartStatus ?  'flipkart':'amazon'
        updatePlatform(platform)
      // if(window.location.href.includes("?")) {
      //   if(platform === 'amazon') { 
      //     navigate('./')
      //   } else {
      //     const url = generateIFrameReportUrl(platform,'Day',passedClientId)
      //     navigate(`./reports?url=${url}`)
      //   }
      //   window.location.reload()
      // } else {
      //   if(platform!=='amazon') { 
      //     const url = generateIFrameReportUrl(platform,'Day',passedClientId)
      //     navigate(`./reports?url=${url}`)
      //   }
      //   window.location.reload(); //Reload the page after change client to load change client data
      // }
       navigate('/')
      }
      setIsSwitching(false);
    } catch (error) {
      alert("Some Unknown Error Occured");
      setIsSwitching(false);
    }

    // Third Party API Function call :- GainSight
  };

  const handleCopy = async (value, label = "Value") => {
    try {
      if (!value) return;
      await copyTextToClipboard(String(value));
      setCopiedField(label);
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }
      copyTimeoutRef.current = setTimeout(() => {
        setCopiedField("");
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  const [optionData, setOptionData] = useState([]);

  const [selectedOption,setSelectedOption] = useState({});

  const setClientInfo = (cid) => {
    const FoundedClient = (
      isMultiUser === "no"
        ? noMultiuserClientsData
        : allClientsData
    ).find((data) => data?.client_id === cid);

    const selectedop = optionData.find((data) => data?.value === cid);
    setSelectedOption(selectedop)

    if (
      FoundedClient !== null &&
      FoundedClient !== undefined
    ) {
      setCurrentClient(FoundedClient);
    } else {
      setCurrentClient({});
    }
  }

  useEffect(() => {
    const c_id = localStorage.getItem("clientId") ? JSON.parse(localStorage.getItem("clientId")) : "";
    setClientInfo(c_id);
  },[optionData])

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const optionlist = (isMultiUser === "no"
      ? [

        {
          name: "Choose Account",
          account_id: "",
          client_id: "",
        },
        ...noMultiuserData,
      ]
      : [...clientsDataToShow]
    );

    const dropdownOptions = optionlist.map((item, index) => ({
      value: item.client_id,
      label: item.name
    }));
    
    setOptionData(dropdownOptions)
  }, [isMultiUser, clientsDataToShow, noMultiuserData])

  const onDropdownOptionChange = (e) => {
    setClientInfo(e.value)
    // const FoundedClient = (
    //   isMultiUser === "no"
    //     ? noMultiuserClientsData
    //     : allClientsData
    // ).find((data) => data?.client_id === e.value);

    // const selectedop = optionData.find((data) => data?.value === e.value);
    // setSelectedOption(selectedop)

    // if (
    //   FoundedClient !== null &&
    //   FoundedClient !== undefined
    // ) {
    //   setCurrentClient(FoundedClient);
    // } else {
    //   setCurrentClient({});
    // }
  }
  const selectedB4Client = b4ClientsData.find(
    (client) => client?.objectId === currentClient?.client_id
  );
  const selectedClientDetails = getSelectedClientDetails(
    currentClient,
    selectedB4Client
  );

  const renderCopyButton = (label, value) => (
    <Tooltip title={copiedField === label ? "Copied" : "Copy"}>
      <span>
        <IconButton
          size="small"
          onClick={() => handleCopy(value, label)}
          disabled={!value}
          sx={{
            border: "1px solid #E5E7EB",
            borderRadius: 1.25,
            minWidth: 30,
            height: 28,
            px: copiedField === label ? 0.75 : 0.4,
          }}
        >
          {copiedField === label ? (
            <Typography variant="caption" sx={{ fontWeight: 700, color: "#2E7D32" }}>
              Copied
            </Typography>
          ) : (
            <img
              className="cursor-pointer-global"
              src={copyIcon}
              alt={`copy ${label}`}
            />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );

  const renderFieldRow = (item, copyKeyPrefix = "", { large = false } = {}) => {
    const copyKey = `${copyKeyPrefix}${item.label}`;
    return (
      <Box
        key={copyKey}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="caption"
            sx={{
              color: "#6B7280",
              display: "block",
              lineHeight: 1.2,
              fontSize: large ? "0.75rem" : "0.65rem",
            }}
          >
            {item.label}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: item.valueColor || "#111827",
              fontWeight: 600,
              wordBreak: "break-word",
              fontSize: large ? "0.875rem" : "0.7rem",
              lineHeight: 1.3,
            }}
          >
            {item.value || "-"}
          </Typography>
        </Box>
        {renderCopyButton(copyKey, item.value)}
      </Box>
    );
  };

  const renderPlatformCard = (title, fields, accentColor) => (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        p: 1.25,
        borderRadius: 1.5,
        backgroundColor: "#FFFFFF",
        border: "1px solid #EEF1F7",
        borderTop: `3px solid ${accentColor}`,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: accentColor,
          fontWeight: 700,
          letterSpacing: 0.4,
          textTransform: "uppercase",
          display: "block",
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <Stack spacing={0.85}>
        {fields.map((item) => renderFieldRow(item, `${title}-`))}
      </Stack>
    </Box>
  );

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const DropdownIndicator = () => {
    return (
      <div
        className={`dropdown-indicator ${isDropdownOpen ? "open" : ""}`}
        onMouseDown={(e) => {
          e.preventDefault();
          setIsDropdownOpen(!isDropdownOpen);
        }}
      >
        <img src={arrowDownIcon} alt="open client dropdown" />
      </div>
    );
  };

  return (
    <>
      <Modal
        show={show}
        onHide={setShow}
        dialogClassName={
          modalFor === "switch-client" ? "switch-client-modal-dialog" : undefined
        }
      >
        <Modal.Header className="portfolio-border">
          <Modal.Title className="text-center">
            {/* {modalFor !== "switch-client"
              ? "Create Portfolio"
              : "Switch Client"} */}
            {modalHeading}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalFor !== "switch-client" ? (
            <>
              <Form.Label> Add Portfolio Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Portfolio Name"
                onChange={handleChange}
              />
            </>
          ) : (
            <>
              <div className="main-body-wrapper">
                {/* <div className="search-bar-container-client-switch mb-3">
                  <span className="search-icon-container">
                    <img
                      src={searchIcon}
                      style={{ zIndex: "1000" }}
                      alt={"search Client"}
                    ></img>
                    <Search color="#4D4184" className="search-icon" />
                  </span>
                  <span className="search-input-container">
                    <input
                      type="text"
                      className={"search-input-field create-campaign-outline"}
                      placeholder={
                        isMultiUser === "no"
                          ? "Filter Account"
                          : "Filter Client"
                      }
                      onChange={filterClients}
                    />
                  </span>
                </div> */}
                <div className="filter-dropdown">
                  {isFetchingClients ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: 3,
                      }}
                    >
                      <CircularProgress size={28} sx={{ color: "#4D4184" }} />
                    </Box>
                  ) : (
                  <div className="select-drop switch-client-select-wrap">
                    <img
                      className="switch-client-search-icon"
                      src={searchIcon}
                      alt="search client"
                    />
                    <Select
                      value={selectedOption}
                      className={`basic-single ${isDropdownOpen ? 'open' : ''}`}
                      classNamePrefix="select"
                      isSearchable={true}
                      options={optionData}
                      onChange={(e) => { onDropdownOptionChange(e) }}
                      components={{ DropdownIndicator }}
                      placeholder={isMultiUser === 'no' ? 'Choose Account' : 'Choose Client'}
                      onFocus={() => setIsDropdownOpen(true)}
                      onBlur={() => setIsDropdownOpen(false)}
                      menuPlacement="auto"
                      menuPosition="fixed"
                    />
                  
                    {/* <select
                      class="form-select"
                      aria-label="Default select example"
                      name="amz_category"
                      isSearchable={true}
                      placeholder={isMultiUser === "no" ? 'Choose Account' : 'Choose Client'}
                      onChange={(e) => {
                        const FoundedClient = (
                          isMultiUser === "no"
                            ? noMultiuserClientsData
                            : allClientsData
                        ).find((data) => data?.client_id === e.target.value);
                        if (
                          FoundedClient !== null &&
                          FoundedClient !== undefined
                        ) {
                          setCurrentClient(FoundedClient);
                        } else {
                          setCurrentClient({});
                        }
                      }}
                    >
                      {(isMultiUser === "no"
                        ? [
                            {
                              name: "Choose Account",
                              account_id: "",
                              client_id: "",
                            },
                            ...noMultiuserData,
                          ]
                        : [...clientsDataToShow]
                      ).map((category, index) => {
                        return (
                          <option
                            value={category.client_id}
                            key={category?.client_id}
                          >
                            {category?.name}
                          </option>
                        );
                      })}
                    </select> */}
                  </div>
                  )}
                </div>
                {/* {Object.keys(currentClient).length !== 0 && ( */}
                {selectedOption && selectedOption.value !== "" && !isFetchingClients && (
                  <Card
                    elevation={0}
                    sx={{
                      mt: 2,
                      borderRadius: 2,
                      border: "1px solid #E6EAF2",
                      background: "linear-gradient(180deg, #FBFCFF 0%, #F6F8FF 100%)",
                    }}
                  >
                    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: "#4D4184", fontWeight: 700, mb: 1.25 }}
                      >
                        Selected Client Details
                      </Typography>

                      <Divider sx={{ mb: 1.25 }} />

                      <Stack spacing={1.25} className="client-id-container">
                        <Box
                          sx={{
                            p: 1.25,
                            borderRadius: 1.5,
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #EEF1F7",
                          }}
                        >
                          <Stack spacing={0.9}>
                            {selectedClientDetails.baseItems.map((item) =>
                              renderFieldRow(item, "", { large: true })
                            )}
                          </Stack>
                        </Box>

                        {(selectedClientDetails.amazonFields ||
                          selectedClientDetails.flipkartFields ||
                          selectedClientDetails.myntraFields) && (
                          <Box
                            sx={{
                              p: 1.25,
                              borderRadius: 1.5,
                              backgroundColor: "#F8FAFF",
                              border: "1px solid #E8ECF6",
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#4D4184",
                                fontWeight: 700,
                                letterSpacing: 0.3,
                                textTransform: "uppercase",
                                display: "block",
                                mb: 1,
                              }}
                            >
                              Platform IDs
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                gap: 1,
                                alignItems: "stretch",
                              }}
                            >
                              {selectedClientDetails.amazonFields &&
                                renderPlatformCard(
                                  "Amazon",
                                  selectedClientDetails.amazonFields,
                                  "#FF9900"
                                )}
                              {selectedClientDetails.flipkartFields &&
                                renderPlatformCard(
                                  "Flipkart",
                                  selectedClientDetails.flipkartFields,
                                  "#2874F0"
                                )}
                              {selectedClientDetails.myntraFields &&
                                renderPlatformCard(
                                  "Myntra",
                                  selectedClientDetails.myntraFields,
                                  "#FF3F6C"
                                )}
                            </Box>
                          </Box>
                        )}
                      </Stack>
                    </CardContent>
                  </Card>
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="portfolio-border">
          <Container
            className={`d-flex gap-2 align-items-center btns-grp ${
              modalFor === "switch-client"
                ? "justify-content-end"
                : "justify-content-center"
            }`}
          >
            {modalFor === "switch-client" ? (
              <>
                <MuiButton
                  size="medium"
                  variant="outlined"
                  onClick={() => setShow(false)}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  Cancel
                </MuiButton>
                <MuiButton
                  size="medium"
                  variant="contained"
                  onClick={() => handleSwitch(currentClient?.client_id)}
                  disabled={
                    isFetchingClients ||
                    isSwitching ||
                    Object.keys(currentClient).length === 0
                  }
                  sx={{ textTransform: "none", fontWeight: 600, boxShadow: "none" }}
                >
                  {isSwitching ? "Switching..." : "Switch"}
                </MuiButton>
              </>
            ) : (
              <>
                <Button
                  className="btns btn-greyish"
                  variant="outline-success"
                  onClick={() => setShow(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="btns"
                  style={{ backgroundColor: "#4D4184", color: "#fff" }}
                  onClick={() => handleSubmit()}
                  disabled={buttonStatus.status}
                >
                  Save
                </Button>
              </>
            )}
          </Container>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PortfoliCreationModal;
